import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { auth, db } from "../api/firebase";
import { doc, getDoc } from "firebase/firestore";

export default function AdminRoute() {
  const [status, setStatus] = useState("loading"); // loading | admin | denied

  useEffect(() => {
    const check = async () => {
      const user = auth.currentUser;
      if (!user) {
        setStatus("denied");
        return;
      }
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        setStatus(snap.exists() && snap.data().isAdmin ? "admin" : "denied");
      } catch {
        setStatus("denied");
      }
    };
    check();
  }, []);

  if (status === "loading") return null;
  if (status === "denied") return <Navigate to="/home" replace />;

  return <Outlet />;
}
